import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';
import { Button } from 'antd';

import LockedContent from 'components/LockedContent';
import NotebookContentComponent from 'components/Notebook/NotebookContent';
import NotebookImageComponent from 'components/Notebook/NotebookImage';
import Icon from 'components/Icon';

const MarketNotebookContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  padding: 20px;
  border-radius: 4px;
  background-color: ${(props) => props.theme.colors['white']};

  .notebook-online-main-container {
    display: grid;
    row-gap: 10px;
    background-color: transparent;
    height: 100%;
  }
`;

const NotebookContentContainer = styled.div<{
  fullContent?: boolean;
}>`
  margin-top: ${(props) => (props.fullContent ? '20px' : 0)};
`;

const ActionButtonContainer = styled(Button).attrs(() => ({
  type: 'primary',
  shape: 'round',
  target: '_blank'
}))`
  background-color: ${(props) => props.theme.colors['terra-cotta']};
  color: ${(props) => props.theme.colors['white']};
  font-family: ${(props) => props.theme.fonts.oswald};
  border: none;
  padding: 3px;
  height: auto;
  width: 100%;

  &.ant-btn-primary:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: ${(props) => props.theme.colors['terra-cotta']};
    color: ${(props) => props.theme.colors['white']};
    border: none;
  }
`;

const ActionButtonComponent = ({
  isActive = true,
  href,
  onClick
}: {
  isActive: boolean;
  href: string;
  onClick?: () => void;
}) => (
  <ActionButtonContainer
    href={href}
    onClick={onClick}
    icon={<Icon icon="download" alt="download-icon" />}
    disabled={!isActive || (!href && !onClick)}
  >
    {I18n.t('dashboard.yourMarketPresentation').toUpperCase()}
  </ActionButtonContainer>
);

type Notebook = {
  name: string;
  networkCode: string;
  releaseDate: string;
  dnClient: number;
  imagePath: string;
  presentationPath?: string | null;
  subscribed: boolean;
  continuousMode: boolean;
  fullContent: boolean;
};

const Notebook = ({
  name,
  networkCode,
  releaseDate,
  dnClient,
  imagePath,
  presentationPath,
  subscribed,
  continuousMode,
  fullContent
}: Notebook) => (
  <LockedContent locked={!subscribed}>
    <MarketNotebookContainer>
      <div className="notebook-online-main-container">
        <NotebookImageComponent
          name={name}
          imagePath={imagePath}
          dnClient={dnClient}
          fullContent={fullContent}
        />
        <NotebookContentContainer fullContent={fullContent}>
          <NotebookContentComponent
            name={name}
            network={networkCode}
            date={releaseDate}
            continiousMode={continuousMode}
          />
        </NotebookContentContainer>
        <div>
          <ActionButtonComponent
            isActive={subscribed && dnClient > 0}
            href={presentationPath || ''}
          />
        </div>
      </div>
    </MarketNotebookContainer>
  </LockedContent>
);

export default Notebook;
